module.exports = __webpack_public_path__ + "static/partners-tek.f9de7dea.svg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/partners-tek.svg
// module id = 265
// module chunks = 0